import { useQuery } from "react-query";

import type { CreditCard } from "@jti/rest-api-types";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { SubscriptionsApi } from "../../../services/subscriptions/SubscriptionsApi";

export const GET_CARD_DATA_QUERY_KEY_BASE = QUERY_KEYS.cardData;

type GetCardDataError = {
  error_code?: "payments::credit_card_not_found" | string;
  correlation_id?: string;
  message?: string;
};

type UseCardDataOptions = {
  updatedCardUUID?: string;
  enabled?: boolean;
};

const RETRY_MAX_FAILURES = 120;
const RETRY_DELAY = 2000;

export const useCardData = ({ updatedCardUUID, enabled = true }: UseCardDataOptions) => {
  const subscriptionsApi = SubscriptionsApi.init();

  return useQuery<CreditCard, GetCardDataError>(
    [QUERY_KEYS.cardData, updatedCardUUID],
    () => subscriptionsApi.getCardData(updatedCardUUID!),
    {
      retry: (attemptCount, error) => {
        return attemptCount < RETRY_MAX_FAILURES && error.error_code === "payments::credit_card_not_found";
      },
      retryDelay: RETRY_DELAY,
      enabled: !!updatedCardUUID && enabled,
    }
  );
};
